<script lang="ts" setup>
// `label` carries the brand's own casing — it feeds the link's accessible name, not the icon lookup.
const links = [
  { name: 'instagram', label: 'Instagram', href: 'https://www.instagram.com/michaelhillj/?hl=en' },
  { name: 'facebook', label: 'Facebook', href: 'https://www.facebook.com/MichaelHillJ/' },
  { name: 'tiktok', label: 'TikTok', href: 'https://www.tiktok.com/@michaelhillfinejewellers' },
  { name: 'pinterest', label: 'Pinterest', href: 'https://www.pinterest.com.au/michaelhillj/' },
  { name: 'linkedin', label: 'LinkedIn', href: 'https://www.linkedin.com/company/michael-hill' },
  { name: 'youtube', label: 'YouTube', href: 'https://www.youtube.com/c/michaelhill', width: 25 },
]
</script>

<template>
  <div class="social-links">
    <h4 class="social-links__title">{{ $t('footer.social_links.title') }}</h4>
    <div class="social-links__list">
      <a
        v-for="{ name, label, href, width } in links"
        :key="name"
        :href="href"
        class="social-links__link"
        target="_blank"
        :aria-label="$t('footer.social_links.link_label', { network: label })"
      >
        <svg-icon :name="`mhj:${name}`" :width="width || 20" />
      </a>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.social-links {
  display: flex;
  flex-direction: column;
  max-width: var(--text-max-width);
  gap: var(--space-40);

  .social-links__title {
    margin-bottom: 0;
  }

  .social-links__list {
    display: flex;
    gap: var(--space-60);
  }

  .social-links__link {
    width: var(--space-60);
    height: var(--space-60);
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      height: auto;
    }
  }
}
</style>
